// import { useEffect } from "react";
// import { useNavigate } from "react-router-dom";

// const withoutAuth = (Component) => {
//   // every page must be binded with withoutAuth in order to make it public.
//   // this component validate user if user is authenticated then it will navigate to dashboard page
//   // else it will redirect to desire page

//   const Auth = (props) => {
//     const router = useNavigate();
//     // const isAuthenticated = useSelector((state) => state.user.isAuthenticated);
//     const token = localStorage.getItem("token");
//     const isAuthenticated = token ? true : false;

//     // useEffect(() => {
//     //   // this code snipet will check is user authenticated or not
//     //   if (isAuthenticated) {
//     //     router("/");
//     //   }  
//     //   // eslint-disable-next-line
//     // }, []);

//     // return desire component if user is unauthenticated
//     return <Component {...props} />;
//   };
//   if (Component.getInitialProps) {
//     Auth.getInitialProps = Component.getInitialProps;
//   }
//   return Auth;
// };

// export default withoutAuth;

import React, { useEffect } from 'react'
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router';

const WithoutAuthLayout = (WrappedComponent) => {
    const WithoutAuthComponent=(props)=>{
        const userObj = useSelector((state)=>state?.userObj);
        const navigate = useNavigate();
        useEffect(()=>{
            const accessToken = userObj?.token;
            if(accessToken){
                navigate("/dashboard");
            }
        },[navigate, userObj]) // Dependency array ensures this effect runs when navigate changes
        return <WrappedComponent {...props}/>
    }
    return WithoutAuthComponent;
}

export default WithoutAuthLayout
